import React from "react";
import CalendlyButton from './components/CalendlyButton';

const Module4 = () => {
  return (
    <div>
      <div className="">
        <h3
          className="text-center fw-bold mt-5 text-white special-font"
          style={{ letterSpacing: "8px", color: "", lineHeight: "22.0px" }}
        >
          COMPARATIVO DE <p></p>INVESTIMENTOS
        </h3>
      </div>
      <div className="container col-12 col-sm-7">
        <p
          className="text-start mt-5 text-white"
          style={{ fontSize: "18px", letterSpacing: "1.8px" }}
        >
          {/* Investir em imóveis sempre foi uma das formas mais seguras e
          consistentes de construir, preservar e aumentar patrimônio ao longo do
          tempo.  */}
          Na IMO Investimentos, nosso foco está em retornos de curto e
          curtíssimo prazos, oferecendo uma grande vantagem em relação a outros
          tipos de investimentos.
        </p>
        <p
          className="text-start mt-4 text-white"
          style={{ fontSize: "18px", letterSpacing: "1.8px" }}
        >
          Além disso, seu capital estará investido em euros, uma moeda forte e
          estável, permitindo não apenas diversificação, mas também uma
          rentabilidade adicional, graças ao histórico de desvalorização do real
          frente ao euro.
          {/* Nossos projetos combinam segurança, alta rentabilidade
          e prazos reduzidos, eliminando os riscos de volatilidade e
          proporcionando resultados consistentes, como você verá a seguir. */}
        </p>
      </div>
      <div className="col d-flex justify-content-center align-content-center mt-5">
        <img
          src="grafico1.png"
          alt="comp_grafico1"
          className="img-fluid"
          style={{ maxHeight: "500px", width: "auto" }}
        />
      </div>

      <div className="container col-12 col-sm-7">
        <p
          className="text-end mt-1 text-white mb-5"
          style={{ fontSize: "12px", lineHeight: "2.0rem" }}
        >
          Os cenários acima foram considerados com apenas 15% de retorno nos
          projetos da IMO Investimento. A depender do projeto os resultados
          podem ser muito maiores.
        </p>
      </div>

      <div className="container col-12 col-md-9 mt-5">
        <h3
          className="text-center fw-bold special-font mb-4 text-white"
          style={{
            letterSpacing: "8px",
            lineHeight: "32px",
          }}
        >
          MAIS LIQUIDEZ, MAIS FLEXIBILIDADE
        </h3>

        <p
          className="text-center special-font text-white"
          style={{
            fontSize: "20px",
            letterSpacing: "1.5px",
            lineHeight: "32px",
            maxWidth: "900px",
            margin: "0 auto 30px auto",
          }}
        >
          Enquanto investimentos tradicionais, como fundos imobiliários
          off-market, costumam imobilizar seu capital por até 60 meses, o modelo
          da IMO Investimentos oferece ciclos de investimento muito mais curtos,
          permitindo que você tenha maior controle e flexibilidade sobre seu
          dinheiro.
        </p>

        <div
          className="row text-white text-center gy-3"
          style={{ maxWidth: "800px", margin: "0 auto" }}
        >
          <div className="col-sm-6">
            <div
              style={{
                backgroundColor: "#111111",
                borderRadius: "12px",
                padding: "20px",
                border: "2px solid #ECA600",
                minHeight: "180px",
              }}
            >
              <h5
                className="fw-bold mb-3"
                style={{ letterSpacing: "2px", color: "#ECA600" }}
              >
                Fundos Imobiliários Tradicionais off-market
              </h5>
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "#D9D9D9",
                }}
              >
                <strong>Carência:</strong> em média 60 meses <br />
                <strong>Liquidez:</strong> baixa (somente após a carência) <br />
                <strong>Flexibilidade:</strong> restrita
              </p>
            </div>
          </div>

          <div className="col-sm-6">
            <div
              style={{
                backgroundColor: "#111111",
                borderRadius: "12px",
                padding: "20px",
                border: "2px solid #ECA600",
                minHeight: "180px",
              }}
            >
              <h5
                className="fw-bold mb-3"
                style={{ letterSpacing: "2px", color: "#ECA600" }}
              >
                IMO INVESTIMENTOS
              </h5>
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "#D9D9D9",
                }}
              >
                <strong>Carência:</strong> média de 6 a 14 meses <br />
                <strong>Liquidez:</strong> alta (resgate possível ao fim de cada
                ciclo) <br />
                <strong>Flexibilidade:</strong> você escolhe reinvestir ou
                resgatar
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="d-flex justify-content-center align-items-center">
  <button
    className="btn border-0 mb-5 mt-5 px-5 py-3 fw-bold"
    style={{
      backgroundColor: "#ECA600",
      letterSpacing: "1.8px",
      borderRadius: "50px",
      fontSize: "1rem",
      color: "black",
      transition: "all 0.3s ease",
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = "#f0b000";
      e.target.style.color = "#fff";
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = "#ECA600";
      e.target.style.color = "black";
    }}
  >
    AUMENTE SEU PATRIMÔNIO INVESTINDO COM A IMO
  </button>
</div> */}
 <div className="mb-4 mt-4">
        
        <CalendlyButton label="AUMENTE SEU PATRIMÔNIO INVESTINDO COM A IMO" />
      </div>

    </div>
  );
};

export default Module4;
